import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SNAgenda } from 'src/app/models/snagenda';
import { AgendaService } from 'src/app/services/agenda.service';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-patient-reminders-login-dialog',
  templateUrl: './patient-reminders-login-dialog.component.html',
  styleUrls: ['./patient-reminders-login-dialog.component.scss']
})
export class PatientRemindersLoginDialogComponent implements OnInit {

  data: any;
  displaymode = 'full';
  public agenda: SNAgenda;

  constructor(private dialogRef: MatDialogRef<PatientRemindersLoginDialogComponent>, @Inject(MAT_DIALOG_DATA) data,
              public patient: PatientService, private agendaSrv: AgendaService) {
    this.data = data;
    if (data.hasOwnProperty('displaymode')) {
      this.displaymode = this.data.displaymode;
    }
  }

  ngOnInit(): void {
    console.log(this.data);
    this.agendaSrv.userAgenda(this.patient.patient).subscribe(agenda => {
      this.agenda = agenda;
    });
  }

  close(code: string) {
    this.dialogRef.close(code);
  }
}
